import React, { Component } from 'react';
import PropTypes from 'prop-types';

import MyArticleBox from '../my-article-box/my-article-box';
import ArticleSuggestionsManager from '../../../services/article-suggestions-manager/article-suggestions-manager';
import articlesService from '../../../services/articles';
import LoadingIndication from '../../common/loading-indicator';
import './article-suggestions.css';

class ArticleSuggestions extends Component {
  constructor(props) {
    super(props);

    this.suggestionManager = new ArticleSuggestionsManager();
    this.state = {
      isLoading: true,
      isError: false
    };
  }
  
  componentDidMount() {
    articlesService.getFullArticles()
      .then(articles => {
        this.setState({
          isLoading: false,
          isError: false,
          suggestions: this.suggestionManager.getSuggestionsByArticle(ArticleSuggestionsManager.Articles, {
            _id: this.props.articleId,
            tags: this.props.articleTags
          })
        });
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          isError: true
        });        
      });
  }
  
  render() {
    if (this.state.isLoading) {
      return (
        <section className='article-suggestions'>
          <LoadingIndication />
        </section>
      );
    }

    if (this.state.isError) {
      return (
        <section className='article-suggestions'>
          <div>Suggestions not found</div>
        </section>
      );
    }

    const articlesJSX = this.state.suggestions.map((article) => 
      <MyArticleBox key={article._id} {...article} />
    );

    if (this.state.suggestions && this.state.suggestions.length === 0) return <span />;

    return (
      <section className='article-suggestions'>
        <h3 className='page-title'>SUGGESTIONS</h3>
        <hr className='title-separator' />

        <div className='suggested-articles'>
          {articlesJSX}
        </div>
      </section>
    );
  }
}

ArticleSuggestions.propTypes = {
  articleId: PropTypes.number.isRequired,
  articleTags: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired
};

export default ArticleSuggestions;